import axios from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

const REQUEST_HEADERS = {
  "Content-Type": "application/json",
};

export function API141() {
  const api = axios.create({
    baseURL: process.env.REACT_APP_EXPERT_URL,
    headers: REQUEST_HEADERS,
    timeout: 10000,
  });
  api.defaults.headers.post["Content-Type"] = "application/json ";
  api.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
  api.defaults.headers.common["Authorization"] = localStorage.getItem("token");

  api.defaults.withCredentials = false;
  // api.defaults.headers.common["Authorization"] =

  api.interceptors.response.use(
    (res) => {
      // const sucsses = res?.data?.result?.message;
      // toast.success(sucsses);
      return res.data.result;
    },
    (error) => {
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        window.location.href = `/login?return-to=${window.location.pathname}`;
        localStorage.removeItem("isExpert");
        localStorage.removeItem("expertId");
        localStorage.removeItem("token");
      } else if (axios.AxiosError.ETIMEDOUT === error.code) {
        toast.error("مشکل در اتصال به اینترنت، در حال تلاش مجدد");
        Swal.fire({
          icon: "error",
          title: "خطا در اتصال به اینترنت ",
          text: "خطا در اتصال به اینترنت",
          confirmButtonText: "تلاش مجدد ",
        }).then((res) => {
          if (res.isConfirmed) {
            window.location.reload();
          }
        });
      } else if (axios.AxiosError.ERR_NETWORK === error.code) {
        // toast.error("1اتصال اینترنت برقرار نمی باشد");
        // Swal.fire({
        //   icon: "error",
        //   title: "خطا در اتصال به اینترنت ",
        //   text: "خطا در اتصال به اینترنت",
        //   confirmButtonText: "تلاش مجدد ",
        // }).then((res) => {
        //   if (res.isConfirmed) {
        //     window.location.reload();
        //   }
        // });
      } else {
        const errorMessage = error?.response?.data?.errors[0]?.message;
        toast.error(errorMessage);
      }
    }
  );

  return api;
}
